<template>
  <div id="app">
    <div v-if="is_logged">
      <admin-layout />
    </div>
    <div v-else>
      <login-screen />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoginScreen from './components/LoginScreen'
import AdminLayout from './components/AdminLayout'

export default {
  name: 'app',
  components: {
    LoginScreen,
    AdminLayout,
  },
  computed: mapState({
    is_logged: (state) => state.username != null && state.password != null && state.server != null,
  }),
}
</script>

<style>
html,
body {
  margin: 0;
  min-height: 100%;
  background: #f5f7fa;
}

body {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #303133;
}

* {
  box-sizing: border-box;
}

#app {
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
  --brand-primary: #fe6600;
  --brand-primary-hover: #ff7d26;
  --brand-primary-active: #e85e00;
  --brand-primary-soft: #fff1e8;
  --brand-primary-border: #ffd0b0;
}

.el-button--primary {
  background-color: var(--brand-primary);
  border-color: var(--brand-primary);
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: var(--brand-primary-hover);
  border-color: var(--brand-primary-hover);
}

.el-button--primary:active {
  background-color: var(--brand-primary-active);
  border-color: var(--brand-primary-active);
}

.el-button--primary.is-plain {
  color: var(--brand-primary);
  background: var(--brand-primary-soft);
  border-color: var(--brand-primary-border);
}

.el-button--danger.is-plain:hover,
.el-button--success.is-plain:hover,
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: #fff;
  background: var(--brand-primary);
  border-color: var(--brand-primary);
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-radio__input.is-checked .el-radio__inner,
.el-switch.is-checked .el-switch__core,
.el-tag.el-tag--primary,
.el-loading-spinner .path,
.el-select-dropdown__item.selected,
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: var(--brand-primary);
  border-color: var(--brand-primary);
}

.el-checkbox__input.is-checked + .el-checkbox__label,
.el-radio__input.is-checked + .el-radio__label,
.el-tabs__item.is-active,
.el-tabs__item:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-button--text,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--brand-primary);
}

.el-pagination button:hover,
.el-pagination button:focus,
.el-pagination .btn-next:hover,
.el-pagination .btn-prev:hover {
  color: #fff !important;
  background-color: var(--brand-primary-hover) !important;
  border-color: var(--brand-primary-hover) !important;
}

.el-select-dropdown__item.selected,
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #fff;
}

.el-input__inner:focus,
.el-textarea__inner:focus,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-checkbox__inner:hover,
.el-radio__inner:hover,
.el-pagination.is-background .el-pager li:not(.disabled).active,
.el-tabs__active-bar {
  border-color: var(--brand-primary);
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  color: var(--brand-primary) !important;
  background-color: var(--brand-primary-soft) !important;
  border-color: var(--brand-primary-border) !important;
}

.el-pagination.is-background .el-pager li:hover {
  color: #fff !important;
  background-color: var(--brand-primary-hover) !important;
  border-color: var(--brand-primary-hover) !important;
}

.el-pagination.is-background .el-pager li.active,
.el-pagination.is-background .el-pager li:not(.disabled).active,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev:disabled {
  color: #fff !important;
  background-color: var(--brand-primary) !important;
  border-color: var(--brand-primary) !important;
}

.el-card {
  border-color: #f3d4bf;
}

.page-shell {
  padding: 24px;
}

.page-breadcrumb {
  margin-bottom: 16px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #303133;
}

.page-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.panel-card {
  border: 1px solid #ebeef5;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 35, 41, 0.06);
}

.status-tag--danger {
  background: #fef0f0;
  border-color: #fbc4c4;
  color: #f56c6c;
}

.status-tag--warning {
  background: #fdf6ec;
  border-color: #f5dab1;
  color: #e6a23c;
}

.status-tag--success {
  background: #f0f9eb;
  border-color: #c2e7b0;
  color: #67c23a;
}

@media (max-width: 767px) {
  .page-shell {
    padding: 16px;
  }

  .page-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .page-title {
    font-size: 24px;
  }
}
</style>
